import React from "react";
import { Input } from "reactstrap";

const NoFormatNumberInput = ({ onChange, placeholder, value, invalid, disabled, hasDecimals=false }) => {
  const pattern = hasDecimals ? "" : "[0-9]*";

  return (
    <Input
      type={"text"}
      placeholder={placeholder}
      value={value || ""}
      invalid={invalid}
      onChange={onChange}
      disabled={disabled}
      pattern={pattern}
    />
  );
};

export default NoFormatNumberInput;
